import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import addBook from "../../redux/books/thunk/addBook";
import updateBook from "../../redux/books/thunk/updateBook";
import { initialValues } from "./initialValues";

const BookForm = () => {
  const bookStore = useSelector((state) => state.book);
  const dispatch = useDispatch();
  // LOCAL DECLARETION START
  const [values, setValues] = useState(initialValues);
  // LOCAL DECLARETION END
  // useEFFECT START
  useEffect(() => {
    Object.keys(bookStore.editData).length !== 0 &&
      setValues({ ...bookStore.editData });
  }, [bookStore.editData]);
  // useEFFECT END
  // HANDLER FUNCTION START
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === "checkbox") {
      setValues({
        ...values,
        [name]: checked,
      });
    } else {
      setValues({
        ...values,
        [name]: value,
      });
    }
  };
  const submitHandler = (e) => {
    e.preventDefault();
    Object.keys(bookStore.editData).length !== 0
      ? dispatch(updateBook(values.id, values, bookStore.filterFeatured))
      : dispatch(addBook(values, bookStore.filterFeatured));
    setValues(initialValues);
  };
  // HANDLER FUNCTION END
  return (
    <>
      <div>
        <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
          <h4 className="mb-8 text-xl font-bold text-center">
            {Object.keys(bookStore.editData).length !== 0
              ? "Update the Book"
              : "Add New Book"}
          </h4>
          <form onSubmit={submitHandler} className="book-form">
            <div className="space-y-2">
              <label htmlFor="name">Book Name</label>
              <input
                required
                className="text-input"
                type="text"
                id="input-Bookname"
                name="name"
                value={values.name}
                onChange={handleInputChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="category">Author</label>
              <input
                required
                className="text-input"
                type="text"
                id="input-Bookauthor"
                name="author"
                value={values.author}
                onChange={handleInputChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="image">Image Url</label>
              <input
                required
                className="text-input"
                type="text"
                id="input-Bookthumbnail"
                name="thumbnail"
                value={values.thumbnail}
                onChange={handleInputChange}
              />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label htmlFor="price">Price</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="input-Bookprice"
                  name="price"
                  value={values.price}
                  onChange={handleInputChange}
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="quantity">Rating</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="input-Bookrating"
                  name="rating"
                  min="1"
                  max="5"
                  value={values.rating}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                id="input-Bookfeatured"
                type="checkbox"
                name="featured"
                className="w-4 h-4"
                checked={values.featured}
                onChange={handleInputChange}
              />
              <label htmlFor="featured" className="ml-2 text-sm">
                {" "}
                This is a featured book{" "}
              </label>
            </div>

            <button type="submit" className="submit" id="submit">
              {Object.keys(bookStore.editData).length !== 0
                ? "Update Book"
                : "Add Book"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default BookForm;
